<template lang="">
  <div class="container">
    <h2>Posibles efectos del alcohol</h2>
    <div class="divider"></div>
      <p>
        El consumo de alcohol es una decisión individual y afecta a las personas de 
        distintas maneras. Algunos estudios han indicado una posible relación entre el 
        consumo de alcohol y un mayor riesgo de padecer ciertos problemas de salud. 
        El consumo de grandes cantidades de manera regular se ha vinculado a diversos 
        padecimientos, como enfermedades hepáticas, enfermedades cardiovasculares, 
        dependencia física y mayor riesgo de ciertos tipos de cáncer. El consumo 
        compulsivo de alcohol, es decir, consumir grandes cantidades de alcohol en un 
        período breve, es peligroso y puede causar graves problemas de salud. En algunas 
        personas, el consumo moderado de alcohol puede incrementar varios riesgos de salud 
        y ciertos tipos de cáncer, como el de mama. Además del ritmo de consumo, otros 
        factores que pueden influir en el nivel de riesgo son la cantidad y frecuencia de 
        consumo, la edad, el sexo, la genética y el estilo de vida. Por lo tanto, debes 
        consultar con tu proveedor de servicios de salud o profesional médico para determinar 
        si el consumo moderado de alcohol es conveniente conforme a tu situación personal de 
        salud.
      </p>
      <p>
        Para mayor información visita: <a target="_blank" href="https://www.moderationmatters.com/mx">https://www.moderationmatters.com/mx</a>
      </p>
  </div>
</template>

<script>
  export default {
    name: "AlcoholAndHealth",
    data: function() {
      return {};
    },
  };
</script>

<style lang="scss" scoped>
  @import '../styles/variables.scss';
  .container {
    padding-bottom: .2rem;
  }
  p {
    font-family: "Wood-Bonnet-Grotesque";
    font-size: 1.3rem;
    text-align: justify;
    color: $green-pantone-7729c;
  }
  .divider {
    border-block: 2.5px $green-pantone-7729c solid;
    width: 100%;
    margin-bottom: 1em;
    margin-top: 0px;
  }
  h2 {
    font-family: "Wood-Bonnet-Grotesque";
    color: $green-pantone-7729c;
    text-transform: uppercase;
    margin-bottom: 0px;
    font-size: 2rem;
    font-weight: 500;
  }
  ul {
    list-style: decimal;
    color: $green-pantone-7729c;
    font-family: "Wood-Bonnet-Grotesque";
    font-size: 1.3rem;
    a {
      font-family: "Wood-Bonnet-Grotesque";
      color: $green-pantone-7729c;
      text-decoration-color: $green-pantone-7729c;
      font-size: 1.3rem;
    }
  }
</style>
  